<!-- 由 suu 创建于 2021-08-17 星期二 -->
<template>
  <div class="CourseReserved">
    <div class="cr-title"
      >已约课程<span>{{ list.length }}节</span></div
    >
    <div class="cr-list">
      <div
        class="cr-item"
        @click="onCourse(item)"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="i-left">
          <div class="left-date">
            <div class="date-num">{{
              item.day.slice(5).replace('-', '.')
            }}</div>
            <div
              class="date-week"
              :class="{ 'date-week-today': getWeek(item.day) == '今日上课' }"
              >{{ getWeek(item.day) }}</div
            >
          </div>
          <div class="left-line"></div>
          <div class="left-time">
            <div class="time-num"
              >{{ item.s_time.slice(11, 16) }}-{{
                item.e_time.slice(11, 16)
              }}</div
            >
            <div class="time-coach"
              >{{ item.coachname }} {{ item.shop_name || item.shopname }}</div
            >
          </div>
        </div>
        <div class="i-close user-btn" @click.stop="cancelAppoint(item)">
          <van-icon name="cross" />
        </div>
      </div>
    </div>
    <CourseCancelPop
      :classInfo="popObj"
      v-if="showCancelPop && popObj"
      @on-close="showCancelPop = false"
      @on-success="handleCancelSuccess"
    />
  </div>
</template>

<script>
import CourseCancelPop from './CourseCancelPop.vue'

export default {
  name: 'CourseReserved',

  components: {
    CourseCancelPop
  },

  props: {
    list: {}
  },

  data() {
    return {
      popObj: null, // 存储当前取消课程信息
      showCancelPop: false
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    // 获取星期几
    getWeek(date) {
      const arr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      const week = new Date(date.replace(/-/g, '/')).getDay()
      // 如果是今天则返回 今日上课
      const today = new Date()
      const todayStr = `${today.getFullYear()}-${String(
        today.getMonth() + 1
      ).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
      if (date === todayStr) {
        return '今日上课'
      }
      return arr[week]
    },
    /**
     * 获取日历日程列表并找到当前取消的课程的日程id
     */
    async calendarChannelMethod() {
      const version = await this.$betterwe.getAppVersion().catch(() => {})
      if (version >= 270) {
        this.$betterwe.deleteGymCourseCalendarEvent(
          this.popObj.s_time,
          this.popObj.e_time
        )
      } else {
        const list = await this.$betterwe.getCalendarList()
        console.log('====================================')
        console.log('listlist', list, this.popObj)
        console.log('====================================')
        if (list?.length && this.popObj?.courseid) {
          const targetItemList = list.filter(
            (item) =>
              item.name ===
              this._formatTime(this.popObj.s_time, this.popObj.e_time)
          )
          console.log('====================================')
          console.log('targetItemList', targetItemList)
          console.log('====================================')
          if (targetItemList?.length) {
            targetItemList.map((v) => {
              try {
                this.$betterwe.deleteCalendar(v.id)
              } catch (error) {
                console.error('删除日历日程失败:', error)
              }
            })
          }
        }
      }
    },
    _formatTime(sTime, eTime) {
      const allDay = sTime.split(' ')[0]
      const day = `${Number(allDay.split('-')[1])}月${Number(
        allDay.split('-')[2]
      )}日`
      const time = `${sTime.slice(-8, -3)}-${eTime.slice(-8, -3)}`
      return `课程时间：${day} ${time}`
    },
    /**
     * 点击某节已预约的课
     */
    onCourse(item) {
      // this.$router.push(
      //   `/course-info?mid=${item.memberappointmentid}'&info=${JSON.stringify(
      //     item
      //   )}`
      // )
      this.$router.push(`scancode?mid=${item.memberappointmentid}`)
    },
    /**
     * 取消成功回调
     */
    handleCancelSuccess(result) {
      this.showCancelPop = false
      this.$toast('取消成功')
      setTimeout(() => {
        location.reload()
      }, 1200)
      // const reload = () => {
      //   setTimeout(() => {
      //     location.reload()
      //   }, 200)
      // }
      // this.$dialog.alert({ message: result.msg }).then(reload)
    },
    /**
     * 取消预约弹窗
     */
    cancelAppoint(obj) {
      this.popObj = obj
      this.showCancelPop = true
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.CourseReserved {
  width: 100%;
  box-sizing: border-box;
  @include flex-c;
  padding: 0 10px;
  margin-bottom: 16px;
  .cr-title {
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    font-size: 14px;
    color: #050b27;
    padding-left: 11px;
    span {
      opacity: 0.3;
      margin-left: 8px;
    }
  }
  .cr-list {
    width: 100%;
    box-sizing: border-box;
    border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
    padding: 10px;
    padding-left: 18px;
    margin-top: 8px;
    .cr-item {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:not(:last-child) {
        margin-bottom: 18px;
      }
      .i-left {
        display: flex;
        align-items: center;
        .left-date {
          text-align: center;
          .date-num {
            font-weight: 500;
            font-size: 15px;
            color: #000000;
            line-height: 20px;
          }
          .date-week {
            font-size: 10px;
            color: rgba($color: #000000, $alpha: 0.8);
            margin-top: 2px;
            &-today {
              font-weight: 600;
              color: #ff2270;
            }
          }
        }
        .left-line {
          margin: 0 16px;
          width: 2px;
          height: 28px;
          background-image: radial-gradient(
            circle,
            #f0f0f0 35%,
            transparent 35%
          );
          background-size: 2px 2.8px;
          background-repeat: repeat-y;
        }
        .left-time {
          .time-num {
            font-weight: 500;
            font-size: 15px;
            color: rgba($color: #000000, $alpha: 1);
          }
          .time-coach {
            font-size: 10px;
            color: rgba($color: #000000, $alpha: 0.5);
            margin-top: 1px;
          }
        }
      }
      .i-close {
        padding: 2px 8px;
        font-size: 14px;
        color: rgba($color: #050b27, $alpha: 0.3);
      }
    }
  }
}
</style>
